export function hasMileDiscrepancy(distance1, distance2, threshold) {
  return (
    distance1 / distance2 >= threshold || distance2 / distance1 >= threshold
  );
}
